<app-modal>
    <ng-container modal-header>
        <p>{{ 'auth.message.passwordChangeMessage' | translate }}</p>
    </ng-container>
    <ng-container modal-body>
        <form
            [formGroup]="setPasswordForm">

            <app-input-password
                [formControl]="setPasswordForm.controls.password"
                [showErrors]="showValidations"
                [placeholder]="'auth.passwordLabel' | translate"
                label="{{ 'auth.passwordLabel' | translate }}">
            </app-input-password>

            <app-input-password
                [formControl]="setPasswordForm.controls.passwordConfirmation"
                [showErrors]="showValidations"
                [placeholder]="'auth.confirmPasswordLabel' | translate"
                label="{{ 'auth.confirmPasswordLabel' | translate }}">
            </app-input-password>
        </form>
        <div class="alert alert-danger" *ngIf="!passwordMatch">
            <strong>{{ 'generic.error' | translate }} </strong> {{ 'auth.passwordNotMatching' | translate }}
        </div>
    </ng-container>
    <ng-container modal-footer>
        <app-button type="primary"
                    (click)="onConfirmChangePassword()">{{ 'generic.buttons.confirm' | translate }}
        </app-button>
    </ng-container>
</app-modal>
